import React, { useState, useEffect } from "react";
import { Form, Button, Container } from "react-bootstrap";
import "./Feedback.scss"

const Feedback = () => {
  const [formData, setFormData] = useState({
    question1: "",
    codeEfficiency: "",
    isModern: "",
    preferInterface: "",
    featureSuggestions: "",
    email:""
  });

  useEffect(() => {
    const savedData = localStorage.getItem("feedbackFormData");
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("feedbackFormData", JSON.stringify(formData));
    console.log("Feedback submitted and saved to local storage!");
  };

  const renderRatingOptions = (questionName) => {
    const options = ["Strongly Disagree", "Disagree", "Neither Agree Nor Disagree", "Agree", "Strongly Agree"];
    return options.map((option, i) => (
      <Form.Check
        inline
        type="radio"
        label={option}
        name={questionName}
        id={`${questionName}-${i}`}
        value={option}
        key={i}
        onChange={handleChange}
        checked={formData[questionName] === option}
      />
    ));
  };

  return (
    <Container>
      <h2 className="my-4">Feedback Form</h2>
      <div className="feedback-form">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label>1. The interface is readable, intuitive, and it&apos;s easy to find information.</Form.Label>
            <div className="feedback-rating">{renderRatingOptions("question1")}</div>
          </Form.Group>

          {/* <Row>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label>2. From Language:</Form.Label>
              <Form.Control
                type="text"
                name="fromLanguage"
                value={formData.fromLanguage}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label>To Language:</Form.Label>
              <Form.Control
                type="text"
                name="toLanguage"
                value={formData.toLanguage}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row> */}

          <Form.Group className="mb-4">
            <Form.Label>2. The interface has the appropriate density of information that allows me to efficiently complete tasks (info density)</Form.Label>
            <div className="feedback-rating">{renderRatingOptions("codeEfficiency")}</div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>3. The interface of UST App Modernisation is modern</Form.Label>
            <div className="feedback-rating">{renderRatingOptions("isModern")}</div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>4. I prefer the new interface</Form.Label>
            <div className="feedback-rating">{renderRatingOptions("preferInterface")}</div>
          </Form.Group>

          {/* <Form.Group className="mb-4">
            <Form.Label>6. How easy was it to use our service?</Form.Label>
            <div className="feedback-rating">{renderRatingOptions(5)}</div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>7. How fast was the conversion process?</Form.Label>
            <div className="feedback-rating">{renderRatingOptions(5)}</div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>8. Did you encounter any errors or issues during the conversion?</Form.Label>
            <div className="feedback-rating">
              <Form.Check
                type="radio"
                label="Yes"
                name="encounteredErrors"
                id="errors-yes"
                value="Yes"
                onChange={handleChange}
              />
              <Form.Check
                type="radio"
                label="No"
                name="encounteredErrors"
                id="errors-no"
                value="No"
                onChange={handleChange}
              />
              {formData.encounteredErrors === "Yes" && (
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="If yes, please describe"
                  name="errorDescription"
                  value={formData.errorDescription}
                  onChange={handleChange}
                />
              )}
            </div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>9. What features would you like to see added to our service?</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="featureSuggestions"
              value={formData.featureSuggestions}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>10. How likely are you to recommend our service to others?</Form.Label>
            <div className="feedback-rating">{renderRatingOptions(10)}</div>
          </Form.Group> */}

          <Form.Group className="mb-4">
            <Form.Label>5. If you could change one thing about the look and feel of APP MODERNIZATION ACCELERATOR to improve the experience, what would it be? - optional</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="featureSuggestions"
              value={formData.featureSuggestions}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>6. We may want to contact you about your feedback. If you agree, provide your email address - optional</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Form.Group>

          <Button variant="primary" type="submit">
          Submit Feedback
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default Feedback;